import React from "react";
import VitalityBoxTable from "./common/VitalityBoxTable";
import BrandingLogo from "./common/BrandingLogo";
import Spam from "../assets/images/Spam.svg"

const LimitedTime = () => {
  return (
    <div className="relative  bottom-0 md:bottom-[128px] pt-8">
      <div className="main-container mx-auto text-center">
        <p className="mb-8 text-[#233751] font-bold md:text-[36px] text-[32px] text-center bold-font">
          Now here’s the Best Part
        </p>
        <div className="md:px-0 px-4">
          <img
            src="https://cdn.blackincae.com/D57-vitality-box-l-otto.png"
            alt=""
            className="mx-auto max-w-full h-auto"
          />
        </div>

        <p className="mt-6 text-[#233751] font-bold text-[20px] text-center px-4 bold-font">
          Together, the retail price for these four research-backed formulations
          is
          <span className="underline text-[#B91111]"> $502.80. </span>
        </p>

        <div className="w-full mt-6">
          <span className="w10gift-highlight-yellow italic bold-font">
            But for a limited time...
          </span>
        </div>

        <p className="mt-6 text-[#233751] font-normal text-[20px] text-center max-w-2xl mx-auto px-10">
          I’m offering you all four
          <span className="bold-font"> life-changing </span>products inside The
          Vitality Box,
          <span className="bold-font"> absolutely FREE for 30 days. </span>
        </p>

        <p className="mt-6 text-[#233751] font-normal text-[20px] text-center md:px-0 px-4">
          All you need to do is cover the $29.95 shipping cost, and I’ll get
          your box out to you right away.
        </p>

        <div className="mt-6 max-w-3xl mx-auto px-2">
          <div
            className="bg-[#B91111] border border-white rounded-[6px] px-2 py-2"
            style={{
              boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)",
              lineHeight: "20px",
            }}
          >
            <div className="flex md:flex-nowrap items-center gap-2 justify-center">
              <img
                src={Spam}
                alt="Brand Logo"
                className="w-[40px] h-[40px]"
              />

              <p className="text-white text-[20px] font-normal">
                <span className="font-bold">WARNING:</span> Now, I need to be
                completely transparent with you about two things. 
              </p>
            </div>
          </div>
        </div>

        <p className="mt-6 flex justify-center items-center px-2">
          <img src="../src/assets/images/golden-boucher.svg" alt="" />
        </p>

        <p className="mt-6 text-[#233751] font-normal text-[20px] text-center md:px-0 px-4">
          Once those boxes are claimed, this offer will be gone for good.
        </p>
      </div>

      <div className="bg-[#EFF6FF] py-4 mt-6">
        <div className="main-container mx-auto text-center">
          <div className="flex gap-4 justify-center items-center">
            <div className="text-black flex items-center gap-4 justify-center">
              <div className="relative">
                <div
                  className="bg-[#B91111] w-16 h-16 rounded-[6px] flex items-center justify-center border border-white"
                  style={{
                    boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)",
                  }}
                >
                  <span className="text-white text-3xl font-bold bold-font">
                    49
                  </span>
                </div>
              </div>
              <div className="text-xl md:text-2xl font-bold text-[#233751] text-start max-w-md bold-font">
                of
              </div>
            </div>
            <div className="text-black flex items-center gap-4 justify-center">
              <div className="relative">
                <div
                  className="bg-[#B91111] w-16 h-16 rounded-[6px] flex items-center justify-center border border-white"
                  style={{
                    boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)",
                  }}
                >
                  <span className="text-white text-3xl font-bold bold-font">
                    200
                  </span>
                </div>
              </div>

              <div className="text-xl md:text-2xl font-bold text-[#233751] text-start max-w-md bold-font">
                Boxes left!
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6">
        <div className="main-container mx-auto text-center">
          <p className="mt-6 text-[#233751] font-normal text-[20px] text-center mx-auto max-w-[620px] md:px-0 px-4">
            So if you want to experience the life-changing benefits of The
            Vitality Box — at absolutely no risk — make sure you claim yours
            right now.
          </p>

          <p className="mt-6 text-[#233751] font-normal text-[20px] text-center md:px-0 px-4">
            Since the page is the ONLY PLACE to take advantage of this AMAZING,
            life-changing offer…
          </p>

        <BrandingLogo />
          <p className="mt-6 text-[#233751] font-normal text-[20px] text-center">
            You need to act fast.
          </p>

          <p className="mt-6 text-[#233751] font-normal text-[20px] text-center px-8">
            If you exit out of this offer right now, you won’t be able to come
            back.
          </p>

          <VitalityBoxTable />
        </div>
      </div>
    </div>
  );
};

export default LimitedTime;
